import * as model from "@/model/prd/productionExecution/smelting/PelletFeeding";
import { newEntityStoreHelper } from "@/store/common/entityModule";
import router from "@/router";
import _ from 'lodash';


function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

const baseStore = newEntityStoreHelper(() => new model.PelletFeeding(), newFilter).buildStore();

function date2str(date) {
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  return `${year}-${month + 1}-${d}`;
}

const baseUrl = process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd";

const pelletFeedingStore = {
  namespaced: true,
  state: {
    baseModuleUrl: baseUrl,
    currentPelletFeeding: {},
  },
  mutations: {
    setCurrentPelletFeeding(state, data) {
      state.currentPelletFeeding = data;
    },
  },
  actions: {
    jumpToEdit(context, item) {
      context.commit("pelletFeeding/currentPelletFeeding", item, {
        root: true
      });
      router.push({
        name: "pelletFeedingEdit"
      });
    },
    findAll(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/pelletFeeding/findAll',
      }, {
          root: true,
        });
    },
    findPage(context, { index, size }) {
      const data = new FormData();
      data.append('page', index)
      data.append('size', size)

      return context.dispatch('api/post', {
        url: baseUrl + '/pelletFeeding/findPage',
        data,
      }, {
          root: true,
        });
    },
    deleteById(context, id) {
      const data = new FormData();
      data.append('id', id)
      return context.dispatch('api/post', {
        url: baseUrl + '/pelletFeeding/delete',
        data,
      }, {
          root: true,
        });
    },
    getLength(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/pelletFeeding/getLength',
      }, { root: true })
    },
    saveCurrentElectrodeResistance(context) {
      return context.dispatch('savePelletFeeding', context.state.currentPelletFeeding);
    },
    saveElectrodeResistance(context, pelletFeeding) {
      let data = new FormData();
      let id = pelletFeeding.id > 0 ? pelletFeeding.id : -1;
      data.append('id', id);
      data.append('date', date2str(pelletFeeding.date));
      data.append('time', pelletFeeding.time);
      data.append('shiftName', pelletFeeding.shiftName);
      data.append('furnaceNumber', pelletFeeding.furnaceNumber);
      data.append('feed1', pelletFeeding.feed1);
      data.append('feed2', pelletFeeding.feed2);
      data.append('feed3', pelletFeeding.feed3);
      data.append('feed4', pelletFeeding.feed4);
      data.append('feed5', pelletFeeding.feed5);
      data.append('feed6', pelletFeeding.feed6);
      data.append('feed7', pelletFeeding.feed7);
      data.append('feed8', pelletFeeding.feed8);
      data.append('feed9', pelletFeeding.feed9);
      data.append('shiftTotal', pelletFeeding.shiftTotal);
      data.append('dailyTotal', pelletFeeding.dailyTotal);
      data.append('tubeTotal', pelletFeeding.tubeTotal);
      data.append('pelletFeedBelt', pelletFeeding.pelletFeedBelt);
      return context.dispatch('api/post', {
        url: baseUrl + '/pelletFeeding/save',
        data,
      }, {
          root: true,
        })
    }
  }
}

export default _.defaultsDeep(pelletFeedingStore, baseStore); // 合并 teamShiftStore 和 baseStore (冲突时选前者)